export enum ActionTypes {
  SET_LOADING = 'SET_LOADING',
  UPDATE_HO_DATA = 'UPDATE_HO_DATA',
  SET_QR_VALIDITY = 'SET_QR_VALIDITY',
}
